var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.26 96.58H37.92v-71.5a5.93 5.93 0 0 1 5.93-5.93h11.48a5.93 5.93 0 0 1 5.93 5.93v71.5zm-20.34-3h17.34v-68.5a2.93 2.93 0 0 0-2.93-2.93H43.85a2.93 2.93 0 0 0-2.93 2.93v68.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.59 49.8H58.76v-16h42.83a8 8 0 0 1 0 16zm-39.83-3h39.83a5 5 0 0 0 0-10H61.76v10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m47.88 37.41-4.39-4.39 2.12-2.12 2.27 2.27 5.69-5.69 2.12 2.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.26 105.46H33.92v-6.31c0-3.07 2.5-5.57 5.57-5.57h20.2c3.07 0 5.57 2.5 5.57 5.57v6.3zm-28.34-3h25.34v-3.31a2.57 2.57 0 0 0-2.56-2.57H39.48a2.57 2.57 0 0 0-2.57 2.57v3.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m46.48 42.48 8.34 8.34-2.12 2.12-8.34-8.34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52.7 42.48 2.11 2.12-8.33 8.34-2.12-2.12z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 122.83C27.68 122.83.17 95.32.17 61.5S27.68.17 61.5.17c33.82 0 61.33 27.51 61.33 61.33s-27.51 61.33-61.33 61.33zm0-119.66C29.34 3.17 3.17 29.34 3.17 61.5s26.17 58.33 58.33 58.33 58.33-26.17 58.33-58.33S93.66 3.17 61.5 3.17z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.05 57.87h3V90.5h-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 102.46h85.16v3H19.35z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.17.17h122.66v122.66H.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppAttendance);
export default ForwardRef;